import { Inputs, InputsProps } from "..";
import * as S from "@/components/atoms/Inputs/InputText/InputText.style";

interface InputTextProps extends InputsProps {
  label?: string;
  required?: boolean;
  maxLength?: number;
  errors?: any;
  success?: any;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showTimer?: boolean;
  timer?: number;
  disabledBorder?: boolean;
}

export const InputText = ({
  label,
  placeholder,
  direction,
  register,
  required,
  maxLength,
  errors,
  success,
  disabled,
  onChange,
  showTimer = false,
  timer = 0,
  disabledBorder,
  value,
}: InputTextProps) => {
  const formatTime = (sec: number) => {
    const minutes = Math.floor(sec / 60);
    const seconds = sec % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  return (
    <Inputs
      label={label && label}
      direction={direction}
      required={required}
      errors={errors}
      success={success}
    >
      <S.InputTextBox $disabledBorder={disabledBorder}>
        <input
          type="text"
          placeholder={placeholder}
          maxLength={maxLength}
          disabled={disabled}
          {...register}
          value={value}
        />
        {showTimer && <S.Timer>{formatTime(timer)}</S.Timer>}
      </S.InputTextBox>
    </Inputs>
  );
};
